import { Flex, Show } from 'shared';

import { NextSessionFormMiroBoardLinkButton } from './Button';

type TNextSessionFormMiroBoardLinkActions = {
  onSave: () => void;
  onEdit: () => void;
  onCopy: () => void;
  isEditMode: boolean;
  isVisible: boolean;
  canLinkBeCopied: boolean;
};

export const NextSessionFormMiroBoardLinkActions = ({
  onSave,
  onEdit,
  onCopy,
  isEditMode,
  isVisible,
  canLinkBeCopied,
}: TNextSessionFormMiroBoardLinkActions) => (
  <Show when={isVisible}>
    <Show
      when={isEditMode}
      fallback={
        <Flex alignItems="center" gap="8px">
          <Show when={canLinkBeCopied}>
            <NextSessionFormMiroBoardLinkButton onClick={onCopy}>
              Copy link
            </NextSessionFormMiroBoardLinkButton>
          </Show>
          <NextSessionFormMiroBoardLinkButton onClick={onEdit}>
            Edit
          </NextSessionFormMiroBoardLinkButton>
        </Flex>
      }
    >
      <NextSessionFormMiroBoardLinkButton onClick={onSave}>
        Save
      </NextSessionFormMiroBoardLinkButton>
    </Show>
  </Show>
);
